import type { SubscriptionButtonProps } from "@product/scmp-sdk";
import dynamic from "next/dynamic";

import type { Props as HeaderOnelineMenuContainerProps } from "~/components/home/header/home-header-oneline-menu-container";

export const DynamicHeaderSubscribeButton = dynamic<SubscriptionButtonProps>(() =>
  import("@product/scmp-sdk").then(module => module.SubscriptionButton),
);

export const DynamicHeaderAvatar = dynamic(() =>
  import("~/components/home/header/header-avatar").then(module => module.HeaderAvatar),
);

export const DynamicHeaderOnelineMenuContainer = dynamic<HeaderOnelineMenuContainerProps>(() =>
  import("~/components/home/header/home-header-oneline-menu-container").then(
    module => module.HomeHeaderOnelineMenuContainer,
  ),
);

export const DynamicHomeNewsTicker = dynamic<Record<string, never>>(() =>
  import("~/components/home/news-ticker").then(module => module.HomeNewsTicker),
);
